export default (seconds) => ({
  initCountdown() {
    if (this.interval) {
      return
    }

    this.timeSeconds = seconds || 5 * 60

    this.interval = setInterval(() => {
      if (this.timeSeconds > 0) {
        this.timeSeconds--
      } else {
        this.timeSeconds = seconds || 5 * 60
      }
    }, 1000)
  },

  format(time) {
    return time.toString().padStart(2, "0")
  },

  hours() {
    if (!this.interval) this.initCountdown()

    return this.format(Math.floor(this.timeSeconds / 3600 || 0))
  },

  minutes() {
    if (!this.interval) this.initCountdown()

    return this.format(Math.floor((this.timeSeconds / 60) % 60) || 0)
  },

  seconds() {
    if (!this.interval) this.initCountdown()

    return this.format(this.timeSeconds % 60 || 0)
  },
})
